import request from './axiosFun'; // 有 loading
import apiHttp from './apiHttp'; // 无 loading

// 助贷接口请求
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}

// 获取用户信息
export function getFinanceUserInfo(data) {
  return apiHttp({
    url: url + '/finance/financeUser/getFinanceUserInfo',
    method: 'post',
    data
  });
}

// 查询机构用户
export function getInstitutionUsers(data) {
  return request({
    url: url + '/finance/financeUser/getInstitutionUsers',
    method: 'post',
    data
  });
}

// 机构用户统计
export function getWatchRoleUserCount(data) {
  return apiHttp({
    url: url + '/finance/financeUser/getWatchRoleUserCount',
    method: 'post',
    data
  });
}
// 机构用户统计2
export function getInstRoleUserCount(data) {
  return apiHttp({
    url: url + '/finance/financeUser/getInstRoleUserCount',
    method: 'post',
    data
  });
}

// 添加机构业务用户
export function saveInstUserInfo(data) {
  return apiHttp({
    url: url + 'finance/financeUser/saveInstUserInfo',
    method: 'post',
    data
  });
}

// 修改机构业务用户
export function updateInstUserInfo(data) {
  return apiHttp({
    url: url + 'finance/financeUser/updateInstUserInfo',
    method: 'post',
    data
  });
}

// 删除用户
export function deleteFianceUser(data) {
  return apiHttp({
    url: url + 'finance/financeUser/deleteFianceUser',
    method: 'post',
    data
  });
}

// 查询监管端用户 /finance/financeUser/getWatchingUsers
export function getWatchingUsers(data) {
  return request({
    url: url + '/finance/financeUser/getWatchingUsers',
    method: 'post',
    data
  });
}

// 添加监管端用户
export function saveWatchingUserInfo(data) {
  return apiHttp({
    url: url + 'finance/financeUser/saveWatchingUserInfo',
    method: 'post',
    data
  });
}
// 编辑监管端用户
export function updateWatchingUserInfo(data) {
  return apiHttp({
    url: url + 'finance/financeUser/updateWatchingUserInfo',
    method: 'post',
    data
  });
}

// 重置用户密码
export function resetPassword(data) {
  return apiHttp({
    url: url + 'finance/financeUser/resetPassword',
    method: 'post',
    data
  });
}

// 查询机构列表（全部）
export function getInstitutionInfoList(data) {
  return apiHttp({
    url: url + '/finance/institutionInfo/getInstitutionInfoList',
    method: 'post',
    data
  });
}

// 查询所有的角色
export function showAllRole(data) {
  return apiHttp({
    // url: url + '/finance/sysRole/showAllRole/' + str,
    url: url + '/finance/sysRole/showAllRole',
    method: 'post',
    data
  });
}
// 查询角色列表
export function pageFinanceSysRole(data) {
  return request({
    url: url + '/finance/sysRole/pageFinanceSysRole',
    method: 'post',
    data
  });
}

// 新增角色
export function saveFinanceSysRole(data) {
  return apiHttp({
    url: url + '/finance/sysRole/saveFinanceSysRole',
    method: 'post',
    data
  });
}

// 修改角色
export function updateFinanceSysRole(data) {
  return apiHttp({
    url: url + '/finance/sysRole/updateFinanceSysRole',
    method: 'post',
    data
  });
}
// 修改角色权限
export function saveRoleMenus(data) {
  return apiHttp({
    url: url + '/finance/sysRole/saveRoleMenus',
    method: 'post',
    data
  });
}
// 获取选中的角色权限
export function webMenuTreeByAppId(data) {
  return apiHttp({
    url: url + '/finance/sysMenu/webMenuTreeByAppId',
    method: 'post',
    data
  });
}

// 删除角色
export function removeFinanceSysRoleById(data) {
  return apiHttp({
    url: url + '/finance/sysRole/removeFinanceSysRoleById/' + data,
    method: 'post'
  });
}

// 查询菜单列表
export function financeSysMenuTree(data) {
  return request({
    url: url + '/finance/sysMenu/financeSysMenuTree',
    method: 'post',
    data
  });
}
// 新增菜单
export function saveFinanceSysMenu(data) {
  return apiHttp({
    url: url + '/finance/sysMenu/saveFinanceSysMenu',
    method: 'post',
    data
  });
}

// 更新菜单
export function updateFinanceSysMenu(data) {
  return apiHttp({
    url: url + '/finance/sysMenu/updateFinanceSysMenu',
    method: 'post',
    data
  });
}
// 删除菜单
export function removeFinanceSysMenuById(data) {
  return apiHttp({
    url: url + '/finance/sysMenu/removeFinanceSysMenuById/' + data,
    method: 'post'
  });
}
// 机构列表分页
export function getInstitutionInfoPage(data) {
  return request({
    url: url + '/finance/institutionInfo/getInstitutionInfoPage',
    method: 'post',
    data
  });
}

// 新增机构
export function addXmdFinanceInstitutionInfo(data) {
  return apiHttp({
    url: url + '/finance/institutionInfo/addXmdFinanceInstitutionInfo',
    method: 'post',
    data
  });
}
// 编辑机构
export function updateById(data) {
  return apiHttp({
    url: url + '/finance/institutionInfo/updateById',
    method: 'post',
    data
  });
}
// 删除机构
export function deleteById(data) {
  return apiHttp({
    url: url + '/finance/institutionInfo/deleteById',
    method: 'post',
    data
  });
}

// 贷后管理列表
export function postLoanListPage(data) {
  return request({
    url: url + '/finance/tradeInfo/postLoanListPage',
    method: 'post',
    data
  });
}

// 申请管理列表
export function pageFinanceApplyOrder(data) {
  return request({
    url: url + '/finance/applyOrder/pageFinanceApplyOrder',
    method: 'post',
    data
  });
}
// 需求详情
export function findRequirementInfoDetail(data) {
  return apiHttp({
    url: url + '/finance/requirementInfo/findRequirementInfoDetail',
    method: 'post',
    data
  });
}
// pc端查看所有用户所有资产信息
export function findFarmPropertyForPC(data) {
  return request({
    url: url + '/finance/financeForUser/findFarmPropertyForPC',
    method: 'post',
    data
  });
}
// 需求监管管理PC端接口
export function findRequirementInfoList(data) {
  return request({
    url: url + '/finance/requirementInfoAdminPc/findRequirementInfoList',
    method: 'post',
    data
  });
}

// PC监管端-查看需求以响应的产品信息
export function pcSuperviseLockResponseProduct(data) {
  return request({
    url: url + '/finance/applyOrder/pcSuperviseLockResponseProduct',
    method: 'post',
    data
  });
}

// 批量审核
export function reviewBatchPdt(data) {
  return apiHttp({
    url: url + '/finance/productAudit/reviewBatchPdt',
    method: 'post',
    data
  });
}

// 系统公告分页查询
export function queryNoticePage(data) {
  return request({
    url: url + '/finance/notice/queryNoticePage',
    method: 'post',
    data
  });
}

// 系统公告新增
export function addNotice(data) {
  return apiHttp({
    url: url + '/finance/notice/addNotice',
    method: 'post',
    data
  });
}

// 系统公告新增
export function deleteNotice(data) {
  return apiHttp({
    url: url + '/finance/notice/deleteNotice',
    method: 'post',
    data
  });
}

// 畜只统计
export function countFarmLivestock(data) {
  return apiHttp({
    url: url + '/finance/financeFarmRecord/countFarmLivestock',
    method: 'post',
    data
  });
}

// 摄像头列表
export function pageDeviceCheckList(data) {
  return request({
    url: url + '/finance/financeDeviceCheck/pageDeviceCheckList',
    method: 'post',
    data
  });
}

// 畜只列表查询
export function pageFarmLivestock(data) {
  return request({
    url: url + '/finance/financeFarmRecord/pageFarmLivestock',
    method: 'post',
    data
  });
}

// 查询用戶牧场列表
export function findUserFarmList(data) {
  return apiHttp({
    url: url + '/finance/financeForUser/findUserFarmList',
    method: 'post',
    data
  });
}
// 设备盘点详情
export function queryCameraDeviceCheckHistory(data) {
  return apiHttp({
    url: url + '/finance/financeDeviceCheck/queryCameraDeviceCheckHistory',
    method: 'post',
    data
  });
}
// // 返回树形菜单集合
// export function financeSysMenuTree(data) {
//   return apiHttp({
//     url: url + '/finance/sysMenu/financeSysMenuTree',
//     method: 'post',
//     data
//   });
// }
// 设备盘点详情
export function findPropertyLivestockCountList(data) {
  return request({
    url: url + '/finance/financeFarmRecord/findPropertyLivestockCountList',
    method: 'post',
    data
  });
}

// // 订单查看详情
// export function findInstitutionPushRequirementDetail(data) {
//   return apiHttp({
//     url: url + '/finance/requirementInfo/findInstitutionPushRequirementDetail',
//     method: 'post',
//     data
//   });
// }



// WEBPACK FOOTER //
// ./src/api/loanAdmin.js